import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import moment from "moment";
import { useDispatch } from "react-redux";
import { loadingFalse, loadingTrue } from "../../../Reducer/loaderSlice";
import Handler from "../../../Helpers/Handler";

// const BASE = "http://localhost/business_community/";
const BASE = "https://qnexus.in/community/";

const ViewPost = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [post, setPost] = useState(null);

  useEffect(() => {
    if (id) fetchPost();
  }, [id]);

  const fetchPost = async () => {
    dispatch(loadingTrue());
    try {
      const res = await Handler({
        method: "get",
        url: `/post/view.php?post_id=${id}`
      });
      if (res?.success && res?.data?.post) {
        setPost(res.data.post);
      }
    } catch (e) {
      Handler(e);
    }
    dispatch(loadingFalse());
  };

  if (!post) return <div style={{ padding: 20 }}>Loading...</div>;

  const hasMedia = post.media?.length > 0;

  return (
    <div className="vp-page">

      {/* Back button */}
      <button className="vp-back" onClick={() => navigate(-1)}>
        ← Back
      </button>

      <div className={`vp-card ${hasMedia ? "vp-card--with-media" : "vp-card--text-only"}`}>

        {/* LEFT — Media */}
        {hasMedia && (
          <div className="vp-media-col">
            {post.media.map((m, i) =>
              m.type?.toUpperCase() === "VIDEO" ? (
                <video
                  key={i}
                  src={BASE + m.url}
                  controls
                  className="vp-media"
                />
              ) : (
                <img
                  key={i}
                  src={BASE + m.url}
                  alt="post"
                  className="vp-media"
                />
              )
            )}
          </div>
        )}

        {/* RIGHT — Details */}
        <div className="vp-details-col">

          {/* Business header */}
          <div className="vp-header">
            <img
              src={BASE + post.logo}
              className="vp-avatar"
              alt=""
            />
            <div>
              <div className="vp-business-name">{post.business_name}</div>
              <div className="vp-date">{moment(post.created_at).fromNow()}</div>
            </div>
          </div>

          {/* Caption */}
          {post.content && (
            <div className="vp-caption">{post.content}</div>
          )}

          {/* Like count */}
          <div className="vp-like-count">
            ❤️ {post.like_count} {post.like_count === 1 ? "Like" : "Likes"}
          </div>

          {/* Liked by */}
          {post.liked_by?.length > 0 && (
            <div className="vp-section">
              <div className="vp-section-title">Liked by</div>
              <div className="vp-liked-list">
                {post.liked_by.map((u, i) => (
                  <div key={i} className="vp-liked-item">
                    <img
                      src={u.logo ? BASE + u.logo : `https://ui-avatars.com/api/?name=${u.business_name}`}
                      alt=""
                      className="vp-liked-avatar"
                    />
                    <span className="vp-liked-name text-capitalize">
                      {u.business_name}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Comments */}
          <div className="vp-section">
            <div className="vp-section-title">
              Comments ({post.comment_count ?? post.comments?.length ?? 0})
            </div>

            {post.comments?.length === 0 && (
              <div className="vp-no-comments">No comments yet</div>
            )}

            <div className="vp-comments-list">
              {post.comments?.map((c, i) => (
                <div key={i} className="vp-comment">
                  <img
                    src={
                      c.commented_by?.logo
                        ? BASE + c.commented_by.logo
                        : `https://ui-avatars.com/api/?name=${c.commented_by?.business_name}`
                    }
                    alt=""
                    className="vp-comment-avatar"
                  />
                  <div className="vp-comment-body">
                    <div className="vp-comment-name text-capitalize">
                      {c.commented_by?.business_name}
                    </div>
                    <div className="vp-comment-text">{c.comment}</div>
                    <div className="vp-comment-time">
                      {moment(c.created_at).fromNow()}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default ViewPost;